export default __webpack_public_path__ + "static/northstar_blue-0cefe09a49660795898538490ed2b216.png";